import {
  Component,
  ElementRef,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { SearchCharacteristic, SearchCharacteristicWithType, SearchType } from "../../models/models";
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { BeerCcSearchProvider } from '../../providers/beer-cc-search/beer-cc-search';
import { BeerCcAnalysisProvider } from '../../providers/beer-cc-analysis/beer-cc-analysis';
import { TranslateService } from '@ngx-translate/core';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

enum ButtonTypes {
  DETAILS_BUTTON,
  DETAILS_CHILD,
  NONE,
  PARENT,
  ONE_TO_FIVE_PARENT,
  ONE_TO_FIVE_CHILD,
  COLOR_PARENT,
  /*COLOR_CHILD,
  COLOR_CHILD_IMAGE,*/
  CELL_COLOR,
  CELL_CLARITY_NO_IMAGE,
  CELL_CLARITY_IMAGE
}

@Component({
  selector: 'beer-cc',
  templateUrl: 'beer-cc.html',
  styleUrls: ['./beer-cc.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})

export class BeerCcComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('ccCanvas') ccCanvas: ElementRef;
  @Input() public type: string;//input variabele that indicates "search" or not, komt binnen via attribuut
  @Output() changed: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  set horizontal(value: number) {
    if (value == 1) {
      this._horizontal = true;
    }
    else {
      this._horizontal = false;
    }
  }
  public colour: number = 0;
  public clarity: number = 0;

  private _CANVAS: any;
  private _CONTEXT: any;

  private _horizontal: boolean;

  public colourname1: string;
  public colourname2: string;

  private timestamp: any;

  buttons: Array<any>;

  //size: number;
  startX: number;
  startY: number;
  xOffset: number;
  yOffsetFull: number;
  yOffsetHalf: number;

  ibaWidth: number = window.innerWidth;
  ibaHeight: number = window.innerWidth;

  middleX: number = 0;
  middleY: number = 0;

  //margins from borders
  left: number = 5;
  right: number = 5;
  top: number = 5;
  bottom: number = 5;

  // a cell is 2 * radius wide
  radius: number = 0;

  cellHeight: number = 0;

  //number of radius that the view is "wide"
  widthCount: number = 5;

  w: number = 0;
  h: number = 0;

  translations;

  private removeColourSubscription: any;
  private setColourSubscription: any;
  private setColoursearchSubscription: any;
  private removeAllSearchSubscription: any;

  constructor(
    private events: AppEventService,
    private bhutil: BhutilProvider,
    private beerCcSearchProvider: BeerCcSearchProvider,
    private beerCcAnalysisProvider: BeerCcAnalysisProvider,
    private translateService: TranslateService
  ) {
    console.log("[beer-cc] - constructor");
    //this._horizontal = true;
    this.timestamp = Date.now();

    console.log("[beer-cc] constructor => " + this.timestamp);

    this.colourname1 = " ";
    this.colourname2 = " ";

    this.clarity = 0;
    this.colour = 0;

    this.initButtons();

  }

  private initButtons() {
    if (this.type == "search") {
      this.buttons = this.beerCcSearchProvider.getButtons();
    }
    else {
      this.buttons = this.beerCcAnalysisProvider.getButtons();
    }
  }

  subscribeEvents() {
    console.log("[beer-cc] subscribeEvents");

    this.removeColourSubscription = (remove) => {
      //debugger;
      console.log("[beer-cc] removing colour selection... => " + this.timestamp);
      //TODO
      this.colour = 0;

      //deselect all colour cells in column 0
      for (const aButton of this.buttons[0].buttons) {
        aButton.selected = false;
      }
      //deselect all colour cells in column 1
      for (const aButton of this.buttons[1].buttons) {
        aButton.selected = false;
      }

      this.colourname1 = " ";
      this.colourname2 = " ";

      this.RefreshCells();

    }
    this.events.subscribe("remove:colour", this.removeColourSubscription);

    this.setColourSubscription = (set) => {
      console.log("[beer-cc] SUB set:colour - setting colour selection... => " + this.timestamp);

      let h = this._horizontal;
      if (h) {
        console.log("[beer-cc] set:colour in search child => ignore");
        return;
      }
      else  {
        console.log("[beer-cc] set:colour in beer-analysis child => go on");
      }

      this.colour = set;

      //deselect all colour cells in column 0
      for (const aButton of this.buttons[0].buttons) {
        aButton.selected = false;
        if (aButton.key === "col" + set) {
          aButton.selected = true;
        }
      }
      //deselect all colour cells in column 1
      for (const aButton of this.buttons[1].buttons) {
        aButton.selected = false;
      }

      let colourName = this.getColourName(set);
      let lines = colourName.split("-");
      if (lines.length == 2) {
        this.colourname1 = lines[0];
        this.colourname2 = lines[1];
      }
      else {
        this.colourname1 = colourName;
        this.colourname2 = " ";
      }

      this.RefreshCells();

    };
    this.events.subscribe("set:colour", this.setColourSubscription);

    this.setColoursearchSubscription = (set) => {
      console.log("[beer-cc] SUB set:coloursearch - setting colour selection... => " + this.timestamp);

      this.colour = set;

      //deselect all colour cells in column 0
      for (const aButton of this.buttons[0].buttons) {
        aButton.selected = false;
        if (aButton.key === "col" + set) {
          aButton.selected = true;
        }
      }
      //deselect all colour cells in column 1
      for (const aButton of this.buttons[1].buttons) {
        aButton.selected = false;
      }

      let colourName = this.getColourName(set);
      let lines = colourName.split("-");
      if (lines.length == 2) {
        this.colourname1 = lines[0];
        this.colourname2 = lines[1];
      }
      else {
        this.colourname1 = colourName;
        this.colourname2 = " ";
      }

      this.RefreshCells();

    };
    this.events.subscribe("set:coloursearch", this.setColoursearchSubscription);

    this.removeAllSearchSubscription = (value) => {
      //debugger;
      console.log("all search params were removed, also removing ours");
      this.colour = -1;

      //deselect all colour cells in column 0
      for (const aButton of this.buttons[0].buttons) {
        aButton.selected = false;
      }
      //deselect all colour cells in column 1
      for (const aButton of this.buttons[1].buttons) {
        aButton.selected = false;
      }
    };
    this.events.subscribe("remove:allsearch", this.removeAllSearchSubscription);
  }

  private confirmSelectedColour() {
    this.buttons.forEach((value1, index1) => {
      let buttonColumn: Array<any> = value1.buttons;
      buttonColumn.forEach((value2,index2) => {
        if (value2.selected) {
          value2.selected = false;
          //debugger; //sel 1
          this.SelectElement(value2);
          this.RefreshCells();
          // only select 1
          return;
//          let colourKey: String = value2.key;
//          let colourNumber: number = parseInt(colourKey.replace("col", ""));
//          return colourNumber;
        }
      });
    });
//    return -1;
  }
  private setSelectedColour(selectedColourIndex: number) {
    this.colour = selectedColourIndex;
    if (selectedColourIndex >= 0) {
      let selectedColourName: string = this.getColourName(selectedColourIndex);
      let colourNameLines = selectedColourName.split("-");
      if (colourNameLines.length == 2) {
        this.colourname1 = colourNameLines[0];
        this.colourname2 = colourNameLines[1];
      }
      else {
        this.colourname1 = selectedColourName;
        this.colourname2 = " ";
      }
    }
    else {
      this.colourname1 = " ";
      this.colourname2 = " ";
    }
  }

  ngOnInit() {

    console.log("[beer-cc] ngOnInit => " + this.timestamp);

    this.initButtons();

    this.subscribeEvents();
  }

  ngOnDestroy() {
    console.log("[beer-cc] ngOnDestroy - " + this.timestamp);

    this.events.unsubscribe("remove:colour", this.removeColourSubscription);
    this.events.unsubscribe("set:colour", this.setColourSubscription);
    this.events.unsubscribe("set:coloursearch", this.setColoursearchSubscription);
    // this.events.unsubscribe("remove:allsearch", this.removeAllSearchSubscription); TODO can/should we unsubscribe?
  }

  initCanvas() {
    if (this._CANVAS.getContext) {
      this.setupCanvas();
    }
  }

  setupCanvas() {
    this._CONTEXT = this._CANVAS.getContext('2d');
    this._CONTEXT.fillStyle = "#ffffff";
    this._CONTEXT.fillRect(0, 0, this.w, this.h);
  }

  clearCanvas() {
    this._CONTEXT.clearRect(0, 0, this._CANVAS.width, this._CANVAS.height);
    this.setupCanvas();
  }

  ngAfterViewInit() {
    console.log("[beer-cc] - ngAfterViewInit");

    this._CANVAS = this.ccCanvas.nativeElement;

    let colourSelectionEventListener = function (event) {
      this._CANVAS.removeEventListener('mouseenter', colourSelectionEventListener, false);
      console.log('click event');
      let x = event.clientX - this._CANVAS.getBoundingClientRect().left;
      let y = event.clientY - this._CANVAS.getBoundingClientRect().top;
      this.checkClickEvent(x, y, this.buttons);
    }.bind(this);

    //console.log("[beer-cc] " + "IBA - size of WINDOW: " + window.innerWidth + " x " + window.innerHeight);
    if (this._horizontal) {
      this.w = window.innerWidth;//full width
      this._CANVAS.width = this.w;

      this.h = 10;
      this._CANVAS.height = this.h;

      this.left = 5;
      this.right = 5;
      this.top = 5;
      this.bottom = 5;

      this.clarity = -1;
      this.colour = -1;

      this._CANVAS.addEventListener('mouseenter', colourSelectionEventListener, false);
      this._CANVAS.addEventListener('click', colourSelectionEventListener, false);

      this.radius = (this.w - this.left - this.right) / 16.0;

      this.left = (this.w - 14 * this.radius) / 2.0;

      this.cellHeight = Math.sqrt(3.0) * this.radius;

      //console.log("[beer-cc] " + "cellheight: " + this.cellHeight);
      let totalHeight = this.cellHeight * 2;
      //console.log("[beer-cc] " + "totalheight: " + totalHeight);
      //console.log("[beer-cc] canvas height: " + this.h);

      /*if (totalHeight > this.h) {
        //omgekeerd te werk gaan
        this.cellHeight = (this.h - 20) / 5;
        this.radius = this.cellHeight / Math.sqrt(3.0);
        this.radius = this.radius * 0.75;

        //let heightDiff = (this.h - totalHeight - this.top - this.bottom) / 2;

        this.cellHeight = this.radius * Math.sqrt(3.0);
        totalHeight = this.cellHeight * 5;

        let heightDiff = (this.h - totalHeight - this.top - this.bottom) / 2;
        console.log("height diff: " + heightDiff);
        if (heightDiff > 0)
          this.top += heightDiff;

        let widthDiff = (this.w - 3 * this.radius - this.left - this.right) / 2;
        if (widthDiff > 0)
          this.left += widthDiff;

        //this.top = heightDiff;
        //this.bottom = heightDiff;
        //this.top = 0;
        //this.bottom = 0;
      } else {
        let heightDiff = (this.h - totalHeight - this.top - this.bottom) / 2;
        //console.log("[beer-cc] " + "heightdiff: " + heightDiff);

        this.top += heightDiff;

      }*/
      this.h = totalHeight + this.bottom + this.top + this.bottom + this.top;
      this._CANVAS.height = this.h;

      this.startX = this.radius;
      this.startY = this.top + this.radius;
      //this.xOffset = 0; //this.radius; //this.size * 1.5;
      this.xOffset = this.radius;
      this.yOffsetFull = this.radius * 1.75;
      this.yOffsetHalf = this.radius * 1.75 / 2;
    }
    else {
      this.w = window.innerWidth * 0.3;
      this._CANVAS.width = this.w;

      this.h = window.innerWidth * 0.6;
      this._CANVAS.height = this.h;

      this.left = 5;
      this.right = 5;
      this.top = 5;
      this.bottom = 5;

      this.clarity = -1;
      this.colour = -1;

      // Tweak for iOS: add mouseenter listener to capture first click
      // remove it after the first click

      this._CANVAS.addEventListener('mouseenter', colourSelectionEventListener, false);
      this._CANVAS.addEventListener('click', colourSelectionEventListener, false);

      //console.log("[beer-cc] " + "IBA - size of CANVAS: " + this.w + " x " + this.h);

      this.radius = (this.w - this.left - this.right) / 3.0;

      this.cellHeight = Math.sqrt(3.0) * this.radius;

      //console.log("[beer-cc] " + "cellheight: " + this.cellHeight);
      let totalHeight = this.cellHeight * 5;
      //console.log("[beer-cc] " + "totalheight: " + totalHeight);
      //console.log("[beer-cc] canvas height: " + this.h);

      if (totalHeight > this.h) {
        //omgekeerd te werk gaan
        this.cellHeight = (this.h - 20) / 5;
        this.radius = this.cellHeight / Math.sqrt(3.0);
        this.radius = this.radius * 0.75;

        //let heightDiff = (this.h - totalHeight - this.top - this.bottom) / 2;

        this.cellHeight = this.radius * Math.sqrt(3.0);
        totalHeight = this.cellHeight * 5;

        let heightDiff = (this.h - totalHeight - this.top - this.bottom) / 2;
        //console.log("height diff: " + heightDiff);
        if (heightDiff > 0)
          this.top += heightDiff;

        let widthDiff = (this.w - 3 * this.radius - this.left - this.right) / 2;
        if (widthDiff > 0)
          this.left += widthDiff;

        //this.top = heightDiff;
        //this.bottom = heightDiff;
        //this.top = 0;
        //this.bottom = 0;
      } else {
        let heightDiff = (this.h - totalHeight - this.top - this.bottom) / 2;
        //console.log("[beer-cc] " + "heightdiff: " + heightDiff);

        this.top += heightDiff;

      }

      this.startX = this.radius;
      this.startY = this.top + this.radius;
      this.xOffset = 0; //this.radius; //this.size * 1.5;
      this.yOffsetFull = this.radius * 1.75;
      this.yOffsetHalf = this.radius * 1.75 / 2;
    }

    this.initCanvas();
    this.drawCells(this.buttons, this.startX, this.startY);

    this.confirmSelectedColour();

  }

  //check in which "field" the click took place
  checkClickEvent(x: number, y: number, buttons: Array<any>) {
    console.log("[beer-cc] " + "er was een click, x: " + x + " y: " + y + " radius: " + this.radius);

    let i = 0;

    let allbuttons: Array<any> = [];
    let col1buttons = buttons[0].buttons;
    let col2buttons = buttons[1].buttons;

    for (const col1elem of col1buttons)
      allbuttons.push(col1elem);
    for (const col2elem of col2buttons)
      allbuttons.push(col2elem);

    //TODO check here for horizontal or vertical!
    for (const element of allbuttons) {
      //console.log("checking button " + i + " x: " + element.x + " y: " + element.y);
      let xpr = element.x + this.radius;
      let xmr = element.x - this.radius;
      let ypr = element.y + this.radius;
      let ymr = element.y - this.radius;
      //console.log("x + r = " + xpr + " x - r = " + xmr + " y + r = " + ypr + " y - r = " + ymr);
      if (this._horizontal) {
        if (y > element.y - this.radius && y < element.y + this.radius && x > element.x - this.radius && x < element.x + this.radius) {
          //console.log("success!")
          //debugger; //sel 2
          this.SelectElement(element);
          this.RefreshCells();
          break;
        }
      }
      else {
        //vertical
        if (y > element.y - this.radius && y < element.y + this.radius && x > element.x - this.radius && x < element.x + this.radius) {
          //debugger; //sel 3
          this.SelectElement(element);
          this.RefreshCells();
          break;
        }
      }
      i++;
    }
  }

  //clear the canvas, draw the canvas again
  private RefreshCells() {
    this._CONTEXT.clearRect(0, 0, this._CANVAS.width, this._CANVAS.height);
    this.drawCells(this.buttons, this.startX, this.startY);
  }

  private getColourName(colourIndex: number): string {
    if (colourIndex == 1) {
      return this.translateService.instant('BEERCC.PALE');
    }
    else if (colourIndex == 2) {
      return this.translateService.instant('BEERCC.BLOND');
    }
    else if (colourIndex == 3) {
      return this.translateService.instant('BEERCC.GOLD');
    }
    else if (colourIndex == 4) {
      return this.translateService.instant('BEERCC.AMBER');
    }
    else if (colourIndex == 5) {
      return this.translateService.instant('BEERCC.COPPER');
    }
    else if (colourIndex == 6) {
      return this.translateService.instant('BEERCC.DARK_COPPER');
    }
    else if (colourIndex == 7) {
      return this.translateService.instant('BEERCC.RED');
    }
    else if (colourIndex == 8) {
      return this.translateService.instant('BEERCC.DARK_BROWN');
    }
    else if (colourIndex == 9) {
      return this.translateService.instant('BEERCC.BLACK');
    }
    return "";
  }

  //select an item in the hive
  private SelectElement(element: any) {
    //console.log("selecting element " + element);

    if (element.detailsButton && element.buttons) {
      element.buttons[5].selected = false;
    }

    if (element.selected) {
      element.selected = false;
    } else {
      //console.log(element);
      if (element.type === ButtonTypes.CELL_COLOR) {
        //console.log("[beer-cc] " + "it was a colour cell");
        //deselect all colour cells in column 0
        for (const aButton of this.buttons[0].buttons) {
          aButton.selected = false;
        }
        //deselect all colour cells in column 1
        for (const aButton of this.buttons[1].buttons) {
          aButton.selected = false;
        }
        //set the colour
        let colIndex = element.key.substr(-1, 1);
        this.colour = colIndex;
        let colourName = this.getColourName(colIndex);
        let lines = colourName.split("-");
        if (lines.length == 2) {
          this.colourname1 = lines[0];
          this.colourname2 = lines[1];
        }
        else {
          this.colourname1 = colourName;
          this.colourname2 = " ";
        }
        //console.log("[beer-cc] " + "Color: " + this.selectedColor + " - clarity: " + this.selectedClarity);

        //emit the event, so the parent can update the beer-spider
        let e: any = {
          color: this.colour,
          clarity: this.clarity
        }
        //console.log("emitting change...");
        console.dir(e);
        this.changed.emit(e);

        let key = "colour";
        let colourCharacteristic: SearchCharacteristic = new SearchCharacteristic(key, colIndex);
        let searchCharacteristicWithType: SearchCharacteristicWithType = new SearchCharacteristicWithType(SearchType.SEARCH_COLOUR, colourCharacteristic);
        if (this.type === "search") {
          //debugger; //publishing colour search value
          this.events.publish("search:colourInput", searchCharacteristicWithType);
        }
        else if (this.type === "analyse") {
          this.events.publish("analyse:colourInput", searchCharacteristicWithType);
        }
        else {
          console.log("[beer-cc] - type is neither search nor analyse");
          //do nothing
        }

      }
      else if (element.type === ButtonTypes.CELL_CLARITY_IMAGE || element.type === ButtonTypes.CELL_CLARITY_NO_IMAGE) {
        //deselect all clarity cells in column 2
        for (const aButton of this.buttons[2].buttons) {
          aButton.selected = false;
        }
        //set the clarity
        let clarIndex = element.key.substr(-1, 1);
        this.clarity = clarIndex;
        //console.log("[beer-cc] " + "Color: " + this.selectedColor + " - clarity: " + this.selectedClarity);

        //emit the event, so the parent can update the beer-spider
        let e: any = {
          color: this.colour,
          clarity: this.clarity
        }
        this.changed.emit(e);
      }

      element.selected = true;
      //console.log("[beer-cc] " + element.key + " has been clicked");

    }
  }

  //deselect the elements
  private DeselectElements(buttons: Array<any>, element: any) {
    let levelOfElement = false;
    for (const b of buttons) {
      if (b === element) {
        levelOfElement = true;
      }
    }
    if (!levelOfElement) {
      for (const b of buttons) {
        if (b.buttons && b.buttons.length > 0) {
          this.DeselectElements(b.buttons, element);
        }
      }
    } else {
      for (const b of buttons) {
        if (b !== element) {
          b.selected = false;
        }
      }
    }

  }

  private drawCells(buttons: Array<any>, x: number, y: number) {

    let col = 0;
    let row = 0;

    if (this._horizontal) {
      for (row = 0; row < buttons.length; row++) {
        let rowX = x + this.left;
        let rowY = this.top + y + row * this.radius * 1.75 / 2;

        if (row == 1)
          rowX += row * this.radius * 3 / 2;
        //rowX += row * Math.sqrt(3.0)/2.0 * this.radius;

        this.drawRowCells(buttons[row].buttons, rowX, rowY, row);

      }
    }
    else {
      for (col = 0; col < buttons.length; col++) {
        let colX = this.left + x + col * this.radius * 3 / 2;
        let colY = y;

        if (col == 1)
          colY += col * Math.sqrt(3.0) * this.radius / 2;

        this.drawColumnCells(buttons[col].buttons, colX, colY, col);

      }
    }


  }

  private drawColumnCells(buttons: Array<any>, x: number, y: number, col: number) {
    let i = 0;

    for (i = 0; i < buttons.length; i++) {
      const b = buttons[i];

      //console.log("drawing button in col " + col + " at index " + i + " --> " + b.key);

      b.x = x;
      b.y = y;
      //this MIGHT fix the issue with multiple bee icons
      b.selected = false;

      //set the selected values
      if (col == 0 || col == 1) {
        //it is a color button
        let colorStr = "col" + this.colour;
        if (b.key === colorStr) {
          b.selected = true;
        }
      }

      //check for color args
      if (b.type === ButtonTypes.CELL_COLOR) {
        let args: any = {
          color: b.colors[0],
          type: b.type,
          selected: b.selected
        };
        this.DrawHexagon(this._CONTEXT, x, y, b.selected, args);

        if (b.selected) {
          //the color button has to be selected
          b.svgPath = "assets/svg/icon_selection_bee.svg";
          this.DrawImage(this._CONTEXT, x, y - 3, false, b, this.radius);
        }
      }
      else {
        this.DrawHexagon(this._CONTEXT, x, y, b.selected, "");
        if (b.type === ButtonTypes.CELL_CLARITY_IMAGE) {
          this.DrawImage(this._CONTEXT, x, y /*- this.radius / 2*/, false, b, this.radius);
        }
      }
      y += this.yOffsetFull;
    }
  }

  private drawRowCells(buttons: Array<any>, x: number, y: number, row: number) {
    let i = 0;

    for (i = 0; i < buttons.length; i++) {
      const b = buttons[i];

      //console.log("drawing button in col " + col + " at index " + i + " --> " + b.key);

      b.x = x;// + i * this.radius;
      b.y = y;

      //set the selected values
      if (row == 0 || row == 1) {
        //it is a color button
        let colorStr = "col" + this.colour;
        if (b.key === colorStr) {
          b.selected = true;
        }
      }

      //check for color args
      if (b.type === ButtonTypes.CELL_COLOR) {
        let args: any = {
          color: b.colors[0],
          type: b.type,
          selected: b.selected
        };
        this.DrawHexagon(this._CONTEXT, x, y, b.selected, args);

        if (b.selected) {
          //the color button has to be selected
          b.svgPath = "assets/svg/icon_selection_bee.svg";
          this.DrawImage(this._CONTEXT, x, y - 3, false, b, this.radius);
        }
      }
      else {
        this.DrawHexagon(this._CONTEXT, x, y, b.selected, "");
        if (b.type === ButtonTypes.CELL_CLARITY_IMAGE) {
          this.DrawImage(this._CONTEXT, x, y /*- this.radius / 2*/, false, b, this.radius);
        }
      }
      //y += this.yOffsetFull;
      x += this.xOffset * 3;
    }
  }

  //draw the hex shapes
  private DrawHexagon(ctx: CanvasRenderingContext2D, x: number, y: number, isSelected: boolean, args: any = null) {
    //con
    //this.radius = this.radius / 2; //* 0.7;
    //console.log("Beer-CC - DrawHexagon - radius: " + this.radius);
    ctx.beginPath();
    ctx.moveTo(x + this.radius * Math.cos(0), y + this.radius * Math.sin(0));

    //Draw hexagon sides
    for (let side = 0; side < 7; side++) {
      ctx.lineTo(x + this.radius * Math.cos(side * 2 * Math.PI / 6), y + this.radius * Math.sin(side * 2 * Math.PI / 6));
    }

    //pick fill type
    if (isSelected) {
      ctx.fillStyle = "#ffdd58";
      ctx.fill();
    }

    if (args.type === ButtonTypes.ONE_TO_FIVE_CHILD) {
      if (args.thisCell <= args.parent.value) {
        ctx.fillStyle = "#ffdd58";
        ctx.fill();
      } else {
        ctx.fillStyle = "#ffffcd";
        ctx.fill();
      }
    }

    if (args.type === ButtonTypes.CELL_COLOR || args.type === ButtonTypes.CELL_CLARITY_NO_IMAGE) {
      //console.log("this is a color type");
      //console.dir(args);
      ctx.fillStyle = args.color;
      ctx.fill();
    }

    //selected clarity cell
    if (args.selected && (args.type === ButtonTypes.CELL_CLARITY_IMAGE || args.type === ButtonTypes.CELL_CLARITY_NO_IMAGE)) {
      ctx.fillStyle = "#ffdd58";
      ctx.fill();
    }

    /*
    //selected color cell => show bee icon
    if (args.selected && args.type === ButtonTypes.COLOR_CHILD) {
      ctx.fillStyle = "#0000ff"; //"#ffdd58";
      ctx.fill();
    }*/

    ctx.strokeStyle = "#ffcc00";
    ctx.lineWidth = 2;
    ctx.stroke();
  }

  //TODO cache
  //draw the image(s) and label(s)
  private DrawImage(ctx: CanvasRenderingContext2D, x: number, y: number, isSelected: boolean, b: any, radius: number) {
    (function (_ctx, _x, _y, _b, _radius) {

      let im = new Image();
      im.src = _b.svgPath; //"assets/svg/apple.png"; //"http://www.html5canvastutorials.com/demos/assets/darth-vader.jpg";
      im.onload = function () {
        let sizeModifier = .75;
        let imSize = _radius * 2;
        _ctx.save();
        _ctx.globalAlpha = 1.0;
        _ctx.drawImage(im, _x - (_radius * sizeModifier), _y - (_radius * sizeModifier), imSize * sizeModifier, imSize * sizeModifier);
        _ctx.restore();
      }.bind(this);
    }.bind(this))(ctx, x, y, b, radius);

  }

}
